import React, {Dispatch, SetStateAction} from 'react';
import {FormOperacionControlOperativoDetalle} from "../types/types";
import {useConfirmationDialog} from "../../../../../hooks/useConfirmationDialog";
import {Box, Card, CardContent, IconButton, Stack, Tooltip} from "@mui/material";
import {UseFormReturn, useWatch} from "react-hook-form";
import DeleteIcon from "@mui/icons-material/Delete";
import ControlOperativoDetalle from "./ControlOperativoDetalle";
import ControlOperativoDetalleForm from "./ControlOperativoDetalleForm";
import {FilePutFields} from "../../../api/file-fields";


interface SeccionControlOperativoDetalleNuevoProps {
  codPais: number,
  formMethods: UseFormReturn<FormOperacionControlOperativoDetalle>,
  detalleProvisional?: FormOperacionControlOperativoDetalle,
  setDetalleProvisional: Dispatch<SetStateAction<FormOperacionControlOperativoDetalle | undefined>>,
}

function SeccionControlOperativoDetalleNuevo({
                                               codPais,
                                               detalleProvisional,
                                               setDetalleProvisional,
                                               formMethods
                                             }: SeccionControlOperativoDetalleNuevoProps) {
  const {askConfirmation} = useConfirmationDialog();

  const {reset} = formMethods;



  const alGuardarDetalleProvisional = (data: FormOperacionControlOperativoDetalle) => {
    setDetalleProvisional(data);
    reset();
  };

  return (
    <>
      {
        !detalleProvisional ? (
            <ControlOperativoDetalleForm codPais={codPais} formMethods={formMethods}
                                         onSubmitForm={alGuardarDetalleProvisional}/>

        ) : (
          <Stack>
            <Card key={'control-operativo-detalle'}>
              <Box display='flex' justifyContent='flex-end'>
                <Tooltip title='Eliminar'>
                  <IconButton
                    onClick={() =>
                      askConfirmation(() =>
                        setDetalleProvisional(undefined as unknown as FormOperacionControlOperativoDetalle)
                      )
                    }
                  >
                    <DeleteIcon color='error'/>
                  </IconButton>
                </Tooltip>
              </Box>
              <CardContent>
                <ControlOperativoDetalle detalle={detalleProvisional}/>
              </CardContent>
            </Card>
          </Stack>
        )
      }
    </>
  );
}

export default SeccionControlOperativoDetalleNuevo;